
import { Step } from "./Onestop";
import { Button, List, ListItem, Icon } from "semantic-ui-react";
import { getStorage, setStorage } from "./Onestop";
import { useNavigate, Link } from "react-router-dom";
import './Onestop.css'

const StepListItem = props => {
    const positiveIcon = <Icon className="check" color="green" />
    const negativeIcon = <Icon className="times" color="red" />

    return <ListItem style={{ padding: "1rem", display: "flex", justifyContent: "space-between", width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between", textAlign: "left", width: "100%" }}>
            <div style={{fontWeight: "bold"}}>{props.text}</div>
            <div style={{marginLeft: "1rem"}}>{props.completed ? positiveIcon : negativeIcon}</div>
        </div>
    </ListItem>
}

export const FinishedStep = props => {
    const storage = getStorage()
    const checklistsCompleted = storage && storage.checklistsCompleted
    const isRepeatReadiness = storage && storage.isRepeatReadiness
    const updatedReadiness = storage && storage.updatedReadiness
    const navigate = useNavigate()

    function resetOnestop() {
        setStorage({})
    }

    return <Step hideIcon={true}>
        <div className="onestop-header">Review</div>
        <List relaxed celled>
            <StepListItem text="Checklist step" completed={checklistsCompleted} />
            <StepListItem text="Readiness step" completed={updatedReadiness || isRepeatReadiness} />
        </List>
        <div>
            <Button onClick={() => {resetOnestop(); navigate('/')}}>Finished</Button>
            <div style={{margin: "1rem", fontWeight: "bold"}}>or</div>
            <Link style={{fontWeight: "bold", fontSize: "1.2rem"}} onClick={() => {resetOnestop(); window.location.reload()}}>Complete for another team</Link>
        </div>

    </Step>
}